import React, {
  createRef,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { Helmet } from "react-helmet-async";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

import { HistoryContext } from "context/HistoryContext";

import backIconImg from "images/icon/back_icon-24x24.png";
import shareIcon from "images/icon/share_icon-24x24.png";
import closeIcon from "images/icon/close_icon-24x24.png";
import bellIconImg from "images/icon/bell_icon-24x24.png";
import moreIconImg from "images/icon/more_icon-24x24.png";
import exitIcon from "images/leave_icon-18x19.png";

import KakaoShareButton from "components/containers/common/KakaoShareButton";

import {
  TopInner,
  TitleTxt,
  Title,
  Back,
  Share,
  BackButtonarea,
  Buttonarea,
  CloseBtnArea,
  CloseBtnWrapper,
  CompleteBtn,
  DisabledCompleteBtn,
  ExitBtn,
  ExitBtnImg,
  BellLink,
  Alarm,
  MatchingBtn,
  ButtonIcon,
  MatchingButtonBlock,
  IconImg,
  More,
} from "./style";
import DotButton from "components/presenters/button/DotButton";

export default function TitleHeader({
  hideBtn = false,
  onBackBtn,
  borderbottom,
  background,
  title,
  isShare,
  shareQueryString,
  shareTitle,
  shareDescription,
  shareImg,
  isCloseBtn,
  prevURL,
  isDotBtn,
  handleModalState,
  showComplete,
  isComplete,
  onCompleteClick,
  showExitBtn,
  onExit,
  animation,
  isSlideOn,
  isNotiBtn,
  newAlarmExist,
  isMatchingBtn = true,
}) {
  const animationClassName =
    animation && (isSlideOn !== null || isSlideOn !== undefined)
      ? isSlideOn === true
        ? "slide_on"
        : "slide_out"
      : null;
  const userInfo = useSelector((state) => {
    return state["userInfo"];
  });

  const [btnAreaWidth, setBtnAreaWidth] = useState(null);
  const [backBtnAreaWidth, setBackBtnAreaWidth] = useState(null);

  const btnAreaRef = useRef(null);
  const backBtnRef = useRef(null);
  const closeBtnRef = useRef(null);

  const kakaoButton = createRef();
  const history = useHistory();

  const historyContext = useContext(HistoryContext);

  const goBack = () => {
    const historyCount = historyContext.historyCount;
    console.log(historyCount);
    console.log(prevURL);
    if (onBackBtn) {
      onBackBtn();
    } else if (prevURL) {
      history.replace(prevURL);
    } else if (historyCount > 1) {
      history.goBack();
    } else {
      history.replace("/");
    }
  };

  const clickShareButton = async () => {
    try {
      kakaoButton.current.click();
    } catch (error) {
      console.log("share btn error");
      console.log(error);
    }
  };

  useEffect(() => {
    if (btnAreaRef?.current?.offsetWidth) {
      setBackBtnAreaWidth(btnAreaRef?.current?.offsetWidth);
    } else if (closeBtnRef?.current?.offsetWidth) {
      setBackBtnAreaWidth(closeBtnRef?.current?.offsetWidth);
    } else {
      setBtnAreaWidth(backBtnRef.current.offsetWidth);
    }
  }, [isShare, isDotBtn, showExitBtn, isNotiBtn, isCloseBtn, showComplete]);

  let btnArea = [];
  if (
    isShare === true ||
    isDotBtn === true ||
    showComplete === true ||
    showExitBtn === true ||
    isNotiBtn === true ||
    isMatchingBtn === true
  ) {
    btnArea.push(
      <Buttonarea
        ref={btnAreaRef}
        width={btnAreaWidth}
        key={"header-title-share-btn"}
      >
        {isShare ? (
          <Share onClick={clickShareButton}>
            <IconImg src={shareIcon} alt={"share button"} />
            <Helmet>
              <script src="https://developers.kakao.com/sdk/js/kakao.js"></script>
            </Helmet>
            <KakaoShareButton
              queryString={shareQueryString}
              kakaoButton={kakaoButton}
              shareTitle={shareTitle}
              shareDescription={shareDescription}
              shareImg={shareImg}
            ></KakaoShareButton>
          </Share>
        ) : null}
        {isDotBtn ? (
          <More onClick={handleModalState}>
            <IconImg src={moreIconImg} />
          </More>
        ) : null}
        {/* WARN: exit button은 이제 쓰일 일이 없나? 만약에 쓰게 된다면 ui가 깨질 것이다. */}
        {showExitBtn ? (
          <ExitBtn
            onClick={(e) => {
              if (onExit) onExit(e);
            }}
          >
            <ExitBtnImg src={exitIcon} />
          </ExitBtn>
        ) : null}
        {isNotiBtn ? (
          userInfo["isLogin"] ? (
            <MatchingButtonBlock>
              <BellLink to={`/mypage/setting/alarm`}>
                <IconImg src={bellIconImg} alt="motiners bell icon" />
                {newAlarmExist ? <Alarm></Alarm> : null}
              </BellLink>
            </MatchingButtonBlock>
          ) : (
            <MatchingButtonBlock>
              <BellLink to={`/social`}>
                <IconImg src={bellIconImg} alt="motiners bell icon" />
              </BellLink>
            </MatchingButtonBlock>
          )
        ) : null}
        {showComplete ? (
          <>
            {isComplete ? (
              <CompleteBtn
                onClick={(e) => {
                  if (onCompleteClick) onCompleteClick();
                }}
              >
                완료
              </CompleteBtn>
            ) : (
              <DisabledCompleteBtn>완료</DisabledCompleteBtn>
            )}
          </>
        ) : null}
      </Buttonarea>
    );
  }

  let headerContent = [];
  if (isCloseBtn) {
    headerContent.push(
      <React.Fragment key={"header-title-content"}>
        <BackButtonarea width={backBtnAreaWidth} ref={backBtnRef} />
        {/* </BackButtonarea> */}
        <Title>
          <TitleTxt>{title ? title : <></>}</TitleTxt>
        </Title>
        <CloseBtnArea ref={closeBtnRef}>
          {hideBtn !== true && (
            <CloseBtnWrapper onClick={goBack}>
              <IconImg src={closeIcon} alt={"close page button"} />
            </CloseBtnWrapper>
          )}
        </CloseBtnArea>
      </React.Fragment>
    );
  } else {
    headerContent.push(
      <React.Fragment key={"header-title-content"}>
        {hideBtn !== true ? (
          <BackButtonarea
            width={backBtnAreaWidth}
            ref={backBtnRef}
          >
            <Back onClick={goBack}>
              <IconImg src={backIconImg} alt={"move to previous page button"} />
            </Back>
          </BackButtonarea>
        ) : (
          <BackButtonarea width={backBtnAreaWidth} ref={backBtnRef}></BackButtonarea>
        )}
        <Title>
          <TitleTxt>{title ? title : <></>}</TitleTxt>
        </Title>
        <CloseBtnArea></CloseBtnArea>
      </React.Fragment>
    );
  }

  return (
    <TopInner
      key={"header-type-title"}
      className={animationClassName}
      style={{ borderBottom: borderbottom, background: background }}
      animation
    >
      {headerContent}
      {isCloseBtn ? null : btnArea}
    </TopInner>
  );
}
